import { useTranslation } from 'react-i18next';
import { useSubscription } from 'services/hooks';
import { StyledChip } from './styled';

const IntervalLabel = () => {
  const { t } = useTranslation();
  const { subscription } = useSubscription();
  const billingInterval = subscription?.recurring?.interval;

  if (!billingInterval) {
    return null;
  }

  if (billingInterval === 'month') {
    return <StyledChip label={t('account:subscription:monthly')} />;
  }
  return <StyledChip label={t('account:subscription:annual')} />;
};

export default IntervalLabel;
